let OS_MANUTENCAO = 2;
let OS_ADESAO_SERVICO = 8;

export {
  OS_ADESAO_SERVICO, OS_MANUTENCAO
};

